  $('#newAddress').on('click', function (e) {
    e.preventDefault();
    $('#newForm').fadeToggle();    
  });
  $('#hideNew').on('click', function (e) {
    e.preventDefault();
    $('#newForm').fadeToggle();   
  }); 
  
  $('.update').on('click', function (e) {
    e.preventDefault();
    var currentID = $(this).attr('data-form-id');
    $('#' + currentID + '').fadeToggle();    
  });  
  $('.close-edit').on('click', function (e) {
    e.preventDefault();
    var currentID = $(this).attr('data-close-id');
    $('#' + currentID + '').fadeToggle();     
  });    
  
  $('.delete').bind('click',function(e){
    e.preventDefault();
    var currentID = $(this).attr('data-form-id'),
        route = $(this).attr('data-route'),
        message = null;
    $('#delete' + currentID).fadeToggle();
    Shopify.CustomerAddress.destroy(currentID,route);
  });  
  
  Shopify.CustomerAddress = {
    destroy: function(currentID,route) {
      $('.deletion-confirmed').on('click', function (e) {
        e.preventDefault();
        //console.log(route+currentID);
        Shopify.postLink(route + '/' + currentID, {'parameters': {'_method': 'delete'}});
      });
    }
  } 